import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/Releases/Settings';

export default {
  get() {
    return httpService.get({
      url: baseUrl,
    });
  },
  update(data) {
    return httpService.put({
      url: baseUrl,
      data,
    });
  },
};
